import type { AgentConnectionType } from "../model/types"
import { readStringEnum } from "./actionArgumentReaders"

const CREATE_AGENT_CONNECTION_TYPES = [
  "inbound_voice",
  "outbound_voice",
  "chat_http",
  "chat_a2a",
  "chat_websocket",
  "sms",
  "voice_websocket",
] as const satisfies readonly AgentConnectionType[]

export const CREATE_AGENT_PHONE_CONNECTIONS: readonly AgentConnectionType[] = [
  "inbound_voice",
  "sms",
]

export const AGENT_CONNECTION_LABELS: Record<AgentConnectionType, string> = {
  inbound_voice: "Inbound Voice",
  outbound_voice: "Outbound Voice",
  chat_http: "Chat (HTTP)",
  chat_a2a: "A2A Chat",
  chat_websocket: "Chat (WebSocket)",
  sms: "SMS",
  voice_websocket: "WebSocket Voice",
}

export const AGENT_CONNECTION_MODEL_TYPES: Record<AgentConnectionType, string> =
  {
    inbound_voice: "MODEL_TYPE_VOICE",
    outbound_voice: "MODEL_TYPE_OUTBOUND_VOICE",
    chat_http: "MODEL_TYPE_CHAT",
    chat_a2a: "MODEL_TYPE_CHAT_A2A",
    chat_websocket: "MODEL_TYPE_CHAT_WEBSOCKET",
    sms: "MODEL_TYPE_SMS",
    voice_websocket: "MODEL_TYPE_WEBSOCKET",
  }

export function createAgentConnectionType(
  args: Record<string, unknown>,
): AgentConnectionType | undefined {
  // Pending signed cards without a connection type represent inbound voice agents.
  if (args.connection_type === undefined || args.connection_type === null) {
    return "inbound_voice"
  }
  return readStringEnum(args, "connection_type", CREATE_AGENT_CONNECTION_TYPES)
}
